import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Loading, showToast } from "../../components";
import {
  bâtimentsService,
  niveauxService,
  espacesService,
  piecesService,
  adressesService,
} from "../../services";
import {
  typeEspaceOptions,
  typologiepieceOptions,
} from "../../utils/constants";
import { useForm } from "react-hook-form";

interface EntityFormProps {
  selectedEntityType: string;
  selectedEntity: any;
  setSelectedEntity: any;
  closeModal: (modalName: string) => void;
  availableNiveaux?: { id: number; nom_niveau: string }[];  // ← nouveau
}

const EntityForm = ({
  selectedEntityType,
  selectedEntity,
  setSelectedEntity,
  closeModal,
  availableNiveaux = [],   // ← nouveau
}: EntityFormProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { register ,
    formState: { errors },
  } = useForm({
    defaultValues: selectedEntity,
  });



  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };

  const onRowEditComplete = async (e) => {
    let { newData, index } = e;
    await adressesService.update(newData.id, newData);
    showToast("success", "Adresses modifié avec succées");
    const updatedAdressTable = selectedEntity?.adresses.map((item) =>
      item.id === newData.id ? newData : item
    );
    setSelectedEntity((prevSelectedEntity) => ({
      ...prevSelectedEntity,
      adresses: updatedAdressTable,
    }));
  };
  const onSubmitBâtiment = async () => {
    try {
      setLoading(true);
      await bâtimentsService.update(selectedEntity?.id, selectedEntity);
      showToast("success", "Bâtiment modifié avec succées");
      setLoading(false);
      closeModal("bâtiment");
    } catch (e) {
      console.log("Error while fetching", e);
      setLoading(false);
    }
  };
  const handleChange = (field, value) => {
    setSelectedEntity((prevEntity) => ({
      ...prevEntity,
      [field]: value,
    }));
  };

  const onSubmitNiveau = async () => {
    try {
      setLoading(true);
      await niveauxService.update(selectedEntity?.id, selectedEntity);
      showToast("success", "Niveau modifié avec succées");
      setLoading(false);
      closeModal("niveau");
    } catch (e) {
      console.log("Error while fetching", e);
      setLoading(false);
    }
  };

  const onSubmitEspace = async () => {
    try {
      setLoading(true);
      await espacesService.update(selectedEntity?.id, selectedEntity);
      showToast("success", "Espace modifié avec succées");
      setLoading(false);
      closeModal("espace");
    } catch (e) {
      console.log("Error while fetching", e);
      setLoading(false);
    }
  };

  const onSubmitPièce = async () => {
    try {
      setLoading(true);
      await piecesService.update(selectedEntity?.id, selectedEntity);
      showToast("success", "Pièce modifié avec succées");
      setLoading(false);
      closeModal("pièce");
    
    } catch (e) {
      console.log("Error while fetching", e);
      setLoading(false);
    }
  };


  

  const [selectedType, setSelectedType] = useState("");
  useEffect(() => {
    if (selectedEntityType === "espace") {

      const foundOption = typeEspaceOptions.find(
        (option) => option.value === selectedEntity?.type_espace?.split(".")[1]
      );

      setSelectedType(foundOption ? foundOption.value : "");  
    } 
    else if (selectedEntityType === "pièce") {
     
      const foundOption =  typologiepieceOptions.find(
        (option) =>option.value ===selectedEntity?.typologie_piece.split(".")[1]
      );
 
      setSelectedType(foundOption ? foundOption.value : ""); 

    
    
    }
  }, [selectedEntity]);



  if (selectedEntityType === "bâtiment") {
    return (
      <>
        <div className="p-6 h-full">
          <img
            src="/images/batiments-3d.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="nom_bâtiment"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Nom
              </label>
              <input
                type="text"
                name="nom_bâtiment"
                id="nom_bâtiment"
                placeholder="Saisir votre nom de bâtiment"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("nom_bâtiment", {
                  required: true,
                })}
                onChange={(e) => handleChange("nom_bâtiment", e.target.value)}
              />
            </div>
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="date_construction"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Date de construction
              </label>
              <input
                type="date"
                name="date_construction"
                id="date_construction"
                placeholder="Saisir votre date de construction"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("date_construction", {
                  required: true,
                })}
                onChange={(e) =>
                  handleChange("date_construction", e.target.value)
                }
              />
            </div>
          </div>
          <div className="mt-5 overflow-x-auto shadow-md overflow-y-auto">
            <DataTable
              value={selectedEntity?.adresses}
              editMode="row"
              dataKey="id"
              onRowEditComplete={onRowEditComplete}
              tableStyle={{ minWidth: "40rem" }}
            >
              <Column
                field="nom_adresse"
                header="nom adresse"
                editor={(options) => textEditor(options)}
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="rue"
                header="Rue"
                editor={(options) => textEditor(options)}
                style={{ width: "10%" }}
              ></Column>
              <Column
                field="rue2"
                header="Rue 2"
                editor={(options) => textEditor(options)}
                style={{ width: "10%" }}
              ></Column>
              <Column
                field="code_postal"
                header="Code postale"
                editor={(options) => textEditor(options)}
                style={{ width: "10%" }}
              ></Column>
              <Column
                field="ville"
                header="ville "
                editor={(options) => textEditor(options)}
                style={{ width: "10%" }}
              ></Column>
              <Column
                field="pays"
                header="Pays"
                editor={(options) => textEditor(options)}
                style={{ width: "10%" }}
              ></Column>
              <Column
                rowEditor
                headerStyle={{ width: "10%", minWidth: "2rem" }}
                bodyStyle={{ textAlign: "center" }}
              ></Column>
            </DataTable>
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => onSubmitBâtiment()}
              className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
            >
              Modifier
            </button>
          </div>
        </div>
        {loading && <Loading />}
      </>
    );
  }
  if (selectedEntityType === "niveau") {
    return (
      <>
        <div className="p-6 h-full">
          <img
            src="/images/couches.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="nom_niveau"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Nom
              </label>
              <input
                type="text"
                name="nom_niveau"
                id="nom_niveau"
                placeholder="Saisir votre nom de niveau"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("nom_niveau", {
                  required: true,
                })}
                value={selectedEntity?.nom_niveau}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    nom_niveau: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numero_ordre"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro d'ordre
              </label>
              <input
                type="text"
                name="numero_ordre"
                id="numero_ordre"
                placeholder="Saisir votre numéro d'ordre"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numero_ordre", {
                  required: true,
                })}
                value={selectedEntity?.numero_ordre}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    numero_ordre: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numero"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro
              </label>
              <input
                type="text"
                name="numero"
                id="numero"
                placeholder="Saisir votre numéro d'ordre"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numero", {
                  required: true,
                })}
                value={selectedEntity?.numero}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    numero: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => onSubmitNiveau()}
              className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
            >
              Modifier
            </button>
          </div>
        </div>
        {loading && <Loading />}
      </>
    );
  }
  if (selectedEntityType === "espace") {
    return (
      <>
        <div className="p-6 h-full">
          <img
            src="/images/espace.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="nom_espace"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Nom
              </label>
              <input
                type="text"
                name="nom_espace"
                id="nom_espace"
                placeholder="Saisir votre nom d'esapce"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("nom_espace", {
                  required: true,
                })}
                value={selectedEntity?.nom_espace}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    nom_espace: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numero"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro
              </label>
              <input
                type="text"
                name="numero"
                id="numero"
                placeholder="Saisir votre numéro"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numero", {
                  required: true,
                })}
                value={selectedEntity?.numero}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    numero: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="type_espace"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Type
              </label>
              <select
                name="type_espace"
                id="type_espace"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("type_espace", {
                  required: true,
                })}
                value={selectedType}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    type_espace: "TypeEspace."+e.target.value,
                  })
                  
                }
              >
                {typeEspaceOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="niveau_id"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Niveau
              </label>
              <select
                name="niveau_id"
                id="niveau_id"
                className="my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5"
                {...register("niveau_id")}
                value={selectedEntity?.niveau_id ?? ""}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    niveau_id: Number(e.target.value),
                  })
                }
              >
                <option value="" disabled>
                  Sélectionner un niveau
                </option>
                {availableNiveaux.map((niveau) => (
                  <option key={niveau.id} value={niveau.id}>
                    {niveau.nom_niveau}
                  </option>
                ))}
              </select>
            </div>
             

            {/* ---- NOUVEAUX CHAMPS ---- */}
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="surface_plancher"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Surface de plancher (m²)
              </label>
              <input
                type="number"
                step="0.01"
                min="0"
                name="sdp"
                id="sdp"
                placeholder="Saisir la surface de plancher"
                className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("sdp", {
                  min: { value: 0, message: "La surface doit être positive" },
                  validate: (value) =>
                    !value ||
                    /^\d+(\.\d{1,2})?$/.test(value) ||
                    "Veuillez entrer un nombre valide (max 2 décimales)",
                })}
                value={selectedEntity?.sdp ?? ""}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    sdp: e.target.value,
                  })
                }
              />
              {errors.sdp && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.sdp.message as string}
                </span>
              )}
            </div>

            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="surface_habitable"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Surface habitable (m²)
              </label>
              <input
                type="number"
                step="0.01"
                min="0"
                name="surface_habitable"
                id="surface_habitable"
                placeholder="Saisir la surface habitable"
                className=" my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("surface_habitable", {
                  min: { value: 0, message: "La surface doit être positive" },
                  validate: (value) =>
                    !value ||
                    /^\d+(\.\d{1,2})?$/.test(value) ||
                    "Veuillez entrer un nombre valide (max 2 décimales)",
                })}
                value={selectedEntity?.surface_habitable ?? ""}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    surface_habitable: e.target.value,
                  })
                }
              />
              {errors.surface_habitable && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.surface_habitable.message as string}
                </span>
              )}
            </div>







          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => onSubmitEspace()}
              className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
            >
              Modifier
            </button>
          </div>
        </div>
        {loading && <Loading />}
      </>
    );
  }
  if (selectedEntityType === "pièce") {
    return (
      <>
        <div className="p-6 h-full">
          <img
            src="/images/piece.png"
            className="mx-auto mb-4 text-gray-400 w-10 h-10 "
          />
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="nom_piece"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Nom
              </label>
              <input
                type="text"
                name="nom_piece"
                id="nom_piece"
                placeholder="Saisir votre nom pièce"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("nom_piece", {
                  required: true,
                })}
                value={selectedEntity?.nom_piece}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    nom_piece: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="typologie_piece"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Type
              </label>
              <select
                name="typologie_piece"
                id="typologie_piece"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("typologie_piece", {
                  required: true,
                })}
                value={selectedType}
                onChange={(e) =>
                  setSelectedEntity({
                    ...selectedEntity,
                    typologie_piece: "Typologie."+e.target.value,
                  })
                }
              >
                {typologiepieceOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => onSubmitPièce()}
              className="text-white mt-5  bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
            >
              Modifier
            </button>
          </div>
        </div>
        {loading && <Loading />}
      </>
    );
  }
};

export default EntityForm;
